const logoutPlaceholder = () => {
    console.log("User seems not to be logged in.");
};

export default logoutPlaceholder;